/**
 * Creates copies of mutable, built-in, non-collection objects,
 * or simply returns the given object for immutable ones.
 *
 * @param  {(-Collection)} obj
 * @return {(-Collection)}
 */
export default function valueCopy (obj) {
  let primitiveObj = obj;
  if (typeof obj === 'object' && Symbol.toPrimitive in obj) {
    primitiveObj = obj[Symbol.toPrimitive]('default');
  }
  // the immutables
  if (obj === null
    || obj === undefined
    || obj === Infinity
    || obj === NaN
    || typeof primitiveObj === 'boolean'
    || typeof primitiveObj === 'number'
    || typeof primitiveObj === 'string'
    || typeof primitiveObj === 'symbol'
    || typeof primitiveObj === 'function'
    || obj instanceof RegExp) {
    return obj;
  }
  // don't use with collections
  if (this.isCollection(obj)) {
    throw new Error('valueCopy cannot be used to copy collections!');
  }

  // mutable built-ins
  if (typeof obj === 'object' && obj instanceof Date) {
    return new Date(obj.valueOf());
  }

  // nothing we know about
  return this.NotApplicable;
}



// WEBPACK FOOTER //
// ./lib/rlink-collections/core/valueCopy.js